// extracted by mini-css-extract-plugin
export default {"header-container":"styles_header-container__GBEHK","main-container":"styles_main-container__v81aV","subheader-container":"styles_subheader-container__VHm71"};